import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';
import SEO from '@/components/base/SEO';
import HeroSection from './components/HeroSection';
import HotMatches from './components/HotMatches';
import CategoryGrid from './components/CategoryGrid';
import NewsSection from './components/NewsSection';
import RankingSection from './components/RankingSection';
import CTASection from './components/CTASection';

export default function Home() {
  const orgSchema = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: 'ky体育',
    url: 'https://www.ky-sports.com',
    description: 'ky体育是专业的在线体育平台，提供丰富的体育赛事、实时数据、竞技资讯与互动体验。',
    contactPoint: {
      '@type': 'ContactPoint',
      telephone: '400-888-6666',
      contactType: 'customer service',
      email: 'contact@ky-sports.com',
      areaServed: 'CN',
      availableLanguage: 'Chinese',
    },
  };

  const webSiteSchema = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: 'ky体育',
    url: 'https://www.ky-sports.com',
    potentialAction: {
      '@type': 'SearchAction',
      target: 'https://www.ky-sports.com/search?q={search_term_string}',
      'query-input': 'required name=search_term_string',
    },
  };

  const webPageSchema = {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    name: 'ky体育 - 官方体育竞技平台',
    description: 'ky体育是专业的在线体育平台，提供丰富的体育赛事、实时数据、竞技资讯与互动体验。',
    url: 'https://www.ky-sports.com/',
    isPartOf: {
      '@type': 'WebSite',
      name: 'ky体育',
      url: 'https://www.ky-sports.com',
    },
  };

  return (
    <>
      <ScrollToTop />
      <SEO
        title="ky体育 - 官方体育竞技平台"
        description="ky体育是专业的在线体育平台，提供丰富的体育赛事、实时数据、竞技资讯与互动体验。ky体育汇聚全球顶级赛事，为体育爱好者打造一站式体育娱乐生态。"
        keywords="ky体育,ky体育官网,ky体育平台,ky体育赛事,ky体育在线,ky体育竞技,ky体育娱乐"
        canonicalUrl="https://www.ky-sports.com/"
        schemaData={[orgSchema, webSiteSchema, webPageSchema]}
      />
      <Navbar />
      <main>
        <HeroSection />
        <HotMatches />
        <CategoryGrid />
        <NewsSection />
        <RankingSection />
        <CTASection />
      </main>
      <Footer />
    </>
  );
}